<template>
  <div v-html="$md.render(md)" class="md" />
</template>
<script>
export default {
  props: {
    md: {
      type: String
    }
  }
}
</script>
<style lang="sass" scoped>
@import '~assets/css/markdown.sass'

div
  @apply leading-loose text-sm
  ::v-deep
    h3
      @apply font-semibold text-base
      margin-top: 3.5rem
    h4, p
      &:nth-child(n+2)
        @apply mt-10
    h4, em
      @apply font-medium text-header not-italic mb-10
      &::before
       content: '──'
       @apply inline-block w-10 tracking-tighter
    a
      @apply text-secondary underline
</style>
